export const facts = [
  {
    level: 'LEVEL 01',
    title: 'Josh Talks',
    color: '#00FFB2',
    body: (
      <div>
        <p><strong>Joined as a Research & Insights Associate. Promoted in 6 months to Program Manager, Founder's Office.</strong></p>
        <p>Worked across all 3 verticals:</p>
        
        <div style={{ marginTop: '16px' }}>
          <p><strong>Media:</strong> 27 YouTube Channels. 200M monthly viewers. 9 languages. 16 categories. 3 people per channel. Tracked channel performance and ran ops to perfect them, one channel at a time.</p>
        </div>
        
        <div style={{ marginTop: '12px' }}>
          <p><strong>B2B:</strong> Figured out the image Josh had built in people's minds. Identified all the touch points. Determined how to fix them (to get more funding).</p>
        </div>
        
        <div style={{ marginTop: '12px' }}>
          <p><strong>LLM Data:</strong> Building multilingual audio datasets for AI companies to train models. Kept the pipeline moving for transcriptionists, evaluators, and QA people.</p>
        </div>
      </div>
    ),
    powerUp: 'knowing how a business looks from the inside',
  },
  {
    level: 'LEVEL 02',
    title: 'Joveo',
    color: '#4A90D9',
    body: (
      <div>
        <p><strong>Joveo helps companies like Uber and Amazon hire in bulk when they enter a new geography.</strong> Connected to 3000+ job boards, they handle the whole applicant pipeline.</p>
        
        <div style={{ marginTop: '16px' }}>
          <p><strong>The Job:</strong> Fulfill the client requirement and figure out how to make money while doing it.</p>
        </div>
        
        <div style={{ marginTop: '12px' }}>
          <p><strong>What that actually meant:</strong></p>
          <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
            <li>Researching new markets from scratch (e.g., if Japan is the new market, what works there, who the players are, what the hiring scene looks like)</li>
            <li>Once clients were live, ran job boards, performance marketing, email campaigns, Facebook with lookalike audiences, and whatever the market needed</li>
            <li>Always watching CPA, always watching quality</li>
          </ul>
        </div>
        
        <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'rgba(74, 144, 217, 0.1)', borderRadius: '4px' }}>
          <p><strong>The numbers:</strong></p>
          <p>Traffic cost: $0.10 | Revenue per lead: $6 | Weekly profits: $10K+</p>
        </div>
      </div>
    ),
    powerUp: 'performance marketing across markets',
  },
  {
    level: 'LEVEL 03',
    title: 'Amazon',
    color: '#FFD700',
    body: (
      <div>
        <p><strong>Amazon needed to onboard a Delivery Service Partner in Brazil.</strong></p>
        
        <div style={{ marginTop: '16px', display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
          <div style={{ flex: '1', minWidth: '200px' }}>
            <p><strong>The requirements</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '12px', listStyle: 'none', paddingLeft: 0 }}>
              <li style={{ marginBottom: '10px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: 0 }}>→</span>
                Pick up truck from a closed list of <strong>15 approved vehicles</strong>
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: 0 }}>→</span>
                Valid <strong>CNPJ</strong>
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: 0 }}>→</span>
                <strong>EAR permits</strong> in place
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: 0 }}>→</span>
                Truck under <strong>15 years old</strong>
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: 0 }}>→</span>
                Driver within <strong>30 to 35 mins</strong> of the commute location
              </li>
            </ul>
          </div>
          
          <div style={{ flex: '1', minWidth: '200px' }}>
            <p><strong>Want the full breakdown?</strong></p>
            <p style={{ marginTop: '12px' }}>
              To know what I did with this: Full breakdown here:{' '}
              <a 
                href="https://medium.com/@sshreshthaa/we-thought-80-of-our-leads-were-qualified-they-werent-2350374fed6e"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#FFD700', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Medium link
              </a>
            </p>
          </div>
        </div>
      </div>
    ),
    powerUp: 'structured problem solving under constraints',
  },
  {
    level: 'LEVEL 04',
    title: 'The Pattern',
    color: '#B24BF3',
    body: (
      <div>
        <p><strong>Three very different problems. One consistent outcome.</strong></p>
        
        <div style={{ marginTop: '16px' }}>
          <p><strong>Josh Talks:</strong> No established playbook. Figure out the way forward, fast.</p>
        </div>
        
        <div style={{ marginTop: '12px' }}>
          <p><strong>Joveo:</strong> Markets are dynamic. Adapt and find what works for success.</p>
        </div>
        
        <div style={{ marginTop: '12px' }}>
          <p><strong>Amazon:</strong> Navigate rigid constraints. Innovate to find a path through.</p>
        </div>
        
        <div style={{ marginTop: '16px', padding: '12px', backgroundColor: 'rgba(178, 75, 243, 0.1)', borderRadius: '4px' }}>
          <p><strong>Core Principle:</strong> It's not about being the most technical expert. It's about being the person who consistently figures out how to get things done.</p>
        </div>
      </div>
    ),
    powerUp: 'relentless problem-solving, regardless of the challenge',
  },
  {
    level: 'FINAL BOSS',
    title: 'D2C',
    color: '#FF3CAC',
    body: (
      <div>
        <p><strong>The difficulty:</strong></p>
        <div style={{ marginTop: '12px' }}>
          <p>In a B2B SaaS company, there are 5 to 15 problems a day.</p>
          <p>D2C is at least <strong>50 problems a day</strong>.</p>
          <p>More moving parts, more things breaking, more decisions in real time.</p>
        </div>
        
        <div style={{ marginTop: '16px' }}>
          <p><strong>Why this level:</strong></p>
          <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
            <li>To see if I can play at that level</li>
            <li>Desire to start my own brand someday</li>
            <li>Before starting a brand, want to understand how D2C actually works from the inside</li>
          </ul>
        </div>
        
        <div style={{ marginTop: '16px', padding: '12px', backgroundColor: 'rgba(255, 60, 172, 0.1)', borderRadius: '4px' }}>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>Status: Ready to play.</p>
        </div>
      </div>
    ),
    powerUp: 'ready for the next level',
  },
];
